import { Typography } from '@material-ui/core';
import React from 'react';
import StateLabel from './StateLabel';
import styles from './ClaimStatusCheck.module.scss';
import Currency from '../Currency';

const renderCurrency = (invoice, valueProp) => {
  const value = invoice[valueProp];
  const placeholder = '- - -';
  return (
    <Currency
      value={value}
      currency={invoice.invoiceCurrency}
      withCurrencyLabel
      placeholder={placeholder}
    />
  );
};

// eslint-disable-next-line import/prefer-default-export
export const getColumns = (isCasco, t) => ([
  {
    title: 'claim.cols.invoiceInputDate',
    property: 'invoiceInputDate',
  },
  {
    title: 'claim.cols.claimState',
    customCell: (row) => <StateLabel invoice={row} />,
  },
  {
    title: 'claim.cols.type',
    property: 'type',
    format: (value) => t(`claim.type.${value}`),
  },
  {
    title: isCasco ? 'claim.cols.assessmentAmount' : 'claim.cols.invoiceAmount',
    customCell: (row) => renderCurrency(row, isCasco ? 'assessmentAmount' : 'invoiceAmount'),
  },
  {
    title: 'claim.cols.settledAmount',
    customCell: (row) => renderCurrency(row, 'settledAmount'),
  },
  {
    title: '',
    sortable: false,
    customCell: (row) => (
      <Typography className={styles.expandText}>
        {row.additionalRow.isOpen ? t('seeLess') : t('seeMore')}
      </Typography>
    ),
  },
]);
